









































































































































































































































import UUIFComponent from '@/shared/uuifComponent';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { TabProps } from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
import { confirmService, ConfirmOptions, ConfirmButton } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { InfoState } from '@/core/core.store';
import { SwStatusInfo } from '@sonicwall/unified-ui-framework/src/shared/sw-status-info';

const cssPrefix = 'transfer-products';

@Component({
  components: {
    ...UUIFComponent,
    SwCheckbox,
    SwStatusInfo,
  },
})
export default class TransferProduct extends SwExtendedVue {
  cssPrefix =  cssPrefix;

  @Prop({ default: [] })
  customerList: any[];

  @Prop()
  openTransferModal: boolean;

  // filteredList: any[] = this.customerList;
  @Prop({ default: [] })
  selectedProducts: any[];
  @Prop()
  sourceCustomer: any;
  selectedTab: string = 'choose-customer';
  searchCustomerValue: string = '';
  selectedCustomer: any = undefined;
  isHideTextBox = false;
  email: string = '';
  name: string = '';
  tabsProps: TabProps[] = [
    { tabId: 'choose-customer', label: `${this.$t('products.transferProducts.customer')}`, disabled : false },
    // { tabId: 'user-details', label: 'User account', disabled : false },
  ];
  buttonsTransferConfirm: ConfirmButton[];
  optionsTransferConfirm: ConfirmOptions;
  confirmTransferFlag: boolean = false;
  transferCheck: boolean = false;
  selectedProductTenantExcluded: any[] = [];
  showDataCenter:boolean = false;
  selectedDataCenterId:string  = '';
  dataCenterList:any [] = [];
  dataCenterMsgConfig: any = {
    initial: {
      isShowMsg : false,
      msgDesc : '',
      msgType : '',
    },
    modified: {},
  };
  bCSCProceedValue: boolean = false;
  bisMSSPProceed: boolean = false;
  cscSerial: string = '';
  showOnpremNote: boolean = false;
  created() {
    // this.filteredList = this.customerList;
    console.warn('trnsfer');
    this.selectedProductTenantExcluded = this.customerList.filter((item) => {
      return  (item.productGroupName !== this.sourceCustomer &&
       (this.selectedProducts.length === 1 ? item.productGroupName !== this.selectedProducts[0].productGroup : true)
      );
    });
    this.dataCenterMsgConfig.modified = this.dataCenterMsgConfig.initial;
  }

  selectCustomer(customer: any) {
    this.selectedCustomer = customer;
    this.isHideTextBox = true;
  }
  mounted() {
    console.warn('selected', this.selectedProducts);
    if (this.selectedProducts) {
      // tslint:disable-next-line:max-line-length
      if (this.selectedProducts.some((item : any) => item.associationType?.toLowerCase() === 'vl primary' || item.productType?.toUpperCase() === 'VOLUME LICENSE')) {
        this.tabsProps[1].disabled = true;
      }
      const onPremSerials = this.selectedProducts.filter((product: any) => {
        return product.pID = '7636';
      });
      if (onPremSerials && onPremSerials.length > 0) {
        this.showOnpremNote = true;
      } else {
        this.showOnpremNote = false;
      }
    }
  }
  get filteredList() {
    return this.selectedProductTenantExcluded.filter((item) => {
      return  (item.productGroupName.toLowerCase()
       .includes(this.searchCustomerValue.toLowerCase())
      );
    });
  }

  get dataCenterOptions() {
    const arr :any[] = [];
    this.dataCenterList.forEach((element: any) => {
      arr.push({
        id: this.selectedTab === 'choose-customer' ? element.locationID :  element.dataCenterId,
        label: this.selectedTab === 'choose-customer' ? element.locationName : element.dataCenterDesc,
        value: this.selectedTab === 'choose-customer' ? element.locationID :  element.dataCenterId,
      });
    });
    return arr;
  }

  clearSelection() {
    this.selectedCustomer = undefined;
    this.isHideTextBox = false;
  }

  transferSerial() {
    if (this.selectedTab === 'choose-customer') {
      this.transferToCustomer();
    } else {
      this.transferToUser();
    }
  }

  transferToUser() {
    if (this.email) {
      const productsList: any[] = [];
      this.selectedProducts.forEach((prod, index) => {
        if (this.confirmTransferFlag) {
          productsList.push({
            // tslint:disable-next-line:max-line-length
            index, serialNumber: prod.serNo, authCode: '', comments: 'Transferring to customer', result: '', commentsDesc: '', s1DeleteAction: '', deletePref: this.transferCheck ? 'YES' : 'NO',
          });
        } else {
          productsList.push({
            index, serialNumber: prod.serNo, authCode: '', comments: 'Transferring to customer', result: '', commentsDesc: '', s1DeleteAction: '',
          });
        }
      });
      const payload1 = { overrideTransferValidate: 'NO',
        request: {
          prodstransferlist: productsList,
          tousernameemail: this.email,
          prodgroup:this.name,
          performautotransfer:'NO',
        },
      };
      let payload = payload1;
      if (this.showDataCenter && this.selectedDataCenterId) {
        const  payload2 = { overrideTransferValidate: 'NO',
          request: {
            prodstransferlist: productsList,
            tousernameemail: this.email,
            prodgroup:this.name,
            performautotransfer:'NO',
            dataCenterId: this.selectedDataCenterId ? this.selectedDataCenterId : '',
          },
        };
        payload = payload2;
      }
      this.$store.commit('startLoading');
      this.$store.dispatch('MswProductsStoreModule/transferSerToUser', payload)
      .then((res) => {
        this.$store.commit('stopLoading');
        this.showDataCenter = false;
        this.selectedDataCenterId = '';
        if (res.msgCode === 'MSWAPP:CSCWARNING') {
          this.confirmTransferFlag = false;
          this.showConfirmDialog(res.msgDesc)
          .then((key) => {
            if (key === 'save') {
              this.$store.commit('startLoading');
              payload.overrideTransferValidate = 'YES';
              this.$store.dispatch('MswProductsStoreModule/transferSerToUser', payload)
              .then((res) => {
                this.$store.commit('stopLoading');
                this.handleResponse_User(res);
              });
            }
          });
        } else {
          this.handleResponse_User(res);
        }
      });
    }
  }

  handleResponse_User(res: any) {
    if (res.msgCode === 'MSWAPP:PRODSTRANSFERSUCCESS') {
      const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc ? res.msgDesc : '' };
      this.$store.commit('enqueueMessage', message);
      this.$emit('transfer-success', { user: this.email });
      this.close();
    } else if (res.msgCode === 'MSWAPP:PREFFILEEXISTS') {
      this.confirmTransferFlag = true;
      const message: InfoState = { infoType: 'major', infoMsg: res.msgDesc };
      this.$store.commit('enqueueMessage', message);
    } else if (res.msgCode === 'MSWAPP:RBACFAILUREMESSAGE') {
      this.confirmTransferFlag = true;
      const message: InfoState = { infoType: 'major', infoMsg: res.msgDesc };
      this.$store.commit('enqueueMessage', message);
    } else if (res.msgCode === 'MSWAPP:DCREQUIRED') {
      this.dataCenterList = res.content.dataCenter;
      this.selectedDataCenterId = this.dataCenterList.filter((ele) => {
        return ele.isDefaultDC === true;
      })[0].dataCenterId;
      this.showDataCenter = true;
    } else {
      this.confirmTransferFlag = false;
      const message: InfoState = { infoType: 'major', infoMsg: res.msgDesc };
      this.$store.commit('enqueueMessage', message);
    }
  }

  transferToCustomer() {
    if (this.selectedCustomer) {
      const serials = this.selectedProducts.filter((item) => {
        return item.productGroup !== this.selectedCustomer.productGroupName;
      });
      const productsList: any[] = [];
      serials.forEach((prod, index) => {
        productsList.push({ index, serialNumber: prod.serNo, name: prod.friendlyName, action: 'add', productGroupId: this.selectedCustomer.productGroupId, msspID: prod.msspId });
      });
      const payload: any = {
        bCSCProceed: this.bCSCProceedValue,
        bsendMail:true,
        productLists: productsList,
        bisMSSPProceed: this.bisMSSPProceed,
      };
      if (this.showDataCenter && this.selectedDataCenterId) {
        payload.dcid = this.selectedDataCenterId;
        payload.cscserial = this.cscSerial ? this.cscSerial : '';
        payload.bCSCProceed = this.bCSCProceedValue ? false : true;
      }
      this.$store.commit('startLoading');
      this.$store.dispatch('MswProductsStoreModule/transferSerToCustomer', payload)
      .then((res) => {
        this.$store.commit('stopLoading');
        if (res.msgCode === 'MSWAPP:CSCWARNING') {
          this.showConfirmDialog(res.msgDesc)
          .then((key) => {
            if (key === 'save') {
              this.bCSCProceedValue = true;
              this.transferToCustomer();
            } else {
              this.bCSCProceedValue = false;
              this.reinitializeDataCenterValues();
            }
          });
        } else if (res.msgCode === 'MSWAPP:MSSPWARNING') {
          this.showConfirmDialog(res.msgDesc, 'YES')
          .then((key) => {
            if (key === 'save') {
              this.bisMSSPProceed = true;
              this.transferToCustomer();
            } else {
              this.bisMSSPProceed = false;
            }
          });
        } else {
          this.handleResponse_Customer(res, serials);
        }
      });
    }
  }

  handleResponse_Customer(res: any, serials : any) {
    if (res.msgCode === 'MSWAPP:MANAGEPRODUCTSSUCCESS') {
      if (this.$store.getters.isLargeCustomer) {
        this.$store.commit('startLoading');
        this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', true)
          .then((response: any) => {
            console.warn(serials, 'ser');
            // const transferedProdGroupId = response.prodGroupLicenseStatus.findIndex((item : any) => item.productGroupId === this.selectedCustomer.productGroupId);
            // serials.forEach((ele : any) => {
            //   if (ele.productType.toLowerCase() === 'firewall') {
            //     const pgIndex = response.prodGroupLicenseStatus.findIndex((item : any) => item.productGroupName === ele.productGroup);
            //     if (pgIndex > -1 && transferedProdGroupId > -1) {
            //       let firewallCountFrom = parseInt(response.prodGroupLicenseStatus[pgIndex].firewallCount, 10);
            //       let firewallCountTo = parseInt(response.prodGroupLicenseStatus[transferedProdGroupId].firewallCount, 10);
            //       firewallCountFrom -= 1;
            //       firewallCountTo += 1;
            //       response.prodGroupLicenseStatus[pgIndex].firewallCount = firewallCountFrom.toString();
            //       response.prodGroupLicenseStatus[transferedProdGroupId].firewallCount = firewallCountTo.toString();
            //     }
            //   } else if (ele.productType.toLowerCase() === 'endpoints') {
            //     const pgIndex = response.prodGroupLicenseStatus.findIndex((item : any) => item.productGroupName === ele.productGroup);
            //     if (pgIndex > -1 && transferedProdGroupId > -1) {
            //       let firewallCountFrom = parseInt(response.prodGroupLicenseStatus[pgIndex].endPointsCount, 10);
            //       let firewallCountTo = parseInt(response.prodGroupLicenseStatus[transferedProdGroupId].endPointsCount, 10);
            //       firewallCountFrom -= 1;
            //       firewallCountTo += 1;
            //       response.prodGroupLicenseStatus[pgIndex].endPointsCount = firewallCountFrom.toString();
            //       response.prodGroupLicenseStatus[transferedProdGroupId].endPointsCount = firewallCountTo.toString();
            //     }
            //   } else if (ele.productType.toLowerCase() === 'access points') {
            //     const pgIndex = response.prodGroupLicenseStatus.findIndex((item : any) => item.productGroupName === ele.productGroup);
            //     if (pgIndex > -1 && transferedProdGroupId > -1) {
            //       let firewallCountFrom = parseInt(response.prodGroupLicenseStatus[pgIndex].accessPointsCount, 10);
            //       let firewallCountTo = parseInt(response.prodGroupLicenseStatus[transferedProdGroupId].accessPointsCount, 10);
            //       firewallCountFrom -= 1;
            //       firewallCountTo += 1;
            //       response.prodGroupLicenseStatus[pgIndex].accessPointsCount = firewallCountFrom.toString();
            //       response.prodGroupLicenseStatus[transferedProdGroupId].accessPointsCount = firewallCountTo.toString();
            //     }
            //   }
            // });
            console.warn('check');
            this.$store.dispatch('MswProductsStoreModule/saveTenantList', response)
            .then(() => {
              this.$store.commit('stopLoading');
              const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
              this.$store.commit('enqueueMessage', message);
              this.$emit('transfer-success', { customer: this.selectedCustomer });
              this.reinitializeDataCenterValues();
              this.bCSCProceedValue = false;
              this.close();
            });
          });
      } else {
        const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
        this.$emit('transfer-success', { customer: this.selectedCustomer });
        this.reinitializeDataCenterValues();
        this.bCSCProceedValue = false;
        this.close();
      }
    } else if (res.msgCode === 'MSWAPP:DCREQUIRED') {
      const dataArrayLists = res.arrListOffSite ? res.arrListOffSite : [];
      if (dataArrayLists.length > 0) {
        this.reinitializeDataCenterValues();
        this.dataCenterList = dataArrayLists;
        this.showOnpremNote = false;
        this.selectedDataCenterId = this.dataCenterList[0].locationID;
        this.showDataCenter = true;
        this.dataCenterMsgConfig.modified.isShowMsg = true;
        this.dataCenterMsgConfig.modified.msgDesc = res.msgDesc ? res.msgDesc : '';
        this.cscSerial = res.cscserial ? res.cscserial : '';
        this.dataCenterMsgConfig.modified.msgType = 'high';
      }
    } else {
      const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
      this.$store.commit('enqueueMessage', message);
    }
  }
  showConfirmDialog(message: string, buttonName?: string) {
    this.buttonsTransferConfirm = [
      { key: 'cancel', name: 'Cancel', isDefault: true },
      { key: 'save', name: buttonName || 'Save' },
    ];
    this.optionsTransferConfirm = {
      message,
      status: 'high',
      title: 'Warning',
      buttons: this.buttonsTransferConfirm,
    };
    return confirmService.confirm(this.optionsTransferConfirm);
  }

  close() {
    this.clearSelection();
    this.$emit('close-tenant-transfer-modal');
  }
  reinitializeDataCenterValues() {
    this.dataCenterMsgConfig.modified =  this.dataCenterMsgConfig.initial;
    this.selectedDataCenterId = '';
    this.showDataCenter = false;
    this.cscSerial = '';
  }
  get getModalWidth() {
    const widthValue:any = {};
    if (this.dataCenterMsgConfig.modified.isShowMsg && this.showDataCenter) {
      widthValue.outer = '650';
      widthValue.inner = '630';
    } else if (this.dataCenterMsgConfig.modified.isShowMsg === false && this.showDataCenter) {
      widthValue.outer = '500';
      widthValue.inner = '450';
    } else {
      widthValue.outer = '341';
      widthValue.inner = '301';
    }
    return widthValue;
  }
}
